export default __webpack_public_path__ + "static/039-0f09da9c721b255876c50f90ac54e8f9.png";